import type { ChatAttachment } from '@shared/api';

/**
 * The opening message is typed on the start screen but sent against a proposal
 * that doesn't exist yet. It rides across the navigation here rather than
 * through the URL.
 */
export interface PendingFirstMessage {
  message: string;
  attachments: ChatAttachment[];
}

let pending: (PendingFirstMessage & { proposalId: string }) | null = null;

export function stashFirstMessage(proposalId: string, message: string, attachments: ChatAttachment[] = []): void {
  pending = { proposalId, message, attachments };
}

export function takeFirstMessage(proposalId: string): PendingFirstMessage | null {
  if (pending?.proposalId !== proposalId) return null;
  const { message, attachments } = pending;
  pending = null;
  return { message, attachments };
}
